import { getPath } from '@/router/common'

const baseUrl = {
  title: '工资管理',
  path: 'paymentWelfare'
}

export default [
  {
    path: getPath('payroll', baseUrl),
    name: 'payroll',
    component: () => import(/* webpackChunkName: "payRoll" */ '@/views/personnelAdministration/paymentWelfare/payRoll/index.vue'),
    meta: {
      title: '工资发放'
    }
  },
  {
    path: getPath('PayrollPopups', baseUrl),
    name: 'PayrollPopups',
    component: () => import(/* webpackChunkName: "PayrollPopups" */ '@/views/personnelAdministration/paymentWelfare/payrollPopups/index.vue'),
    meta: {
      title: '员工工资发放'
    }
  },
  {
    path: getPath('PayrollPopups79358', baseUrl),
    name: 'PayrollPopups79358',
    component: () => import(/* webpackChunkName: "PayrollPopups79358" */ '@/views/personnelAdministration/paymentWelfare/payrollPopups79358/index.vue'),
    meta: {
      title: '员工工资发放'
    }
  },
  {
    path: getPath('StatisticsIndex', baseUrl),
    name: 'StatisticsIndex',
    component: () => import(/* webpackChunkName: "StatisticsIndex" */ '@/views/personnelAdministration/paymentWelfare/statisticsIndex/index.vue'),
    meta: {
      title: '人员统计'
    }
  },
  {
    path: getPath('PayrollPopups', baseUrl),
    name: 'PaymentWelfarePayrollPopups',
    component: () => import(/* webpackChunkName: "PaymentWelfarePayrollPopups" */ '@/views/paymentWelfare/payrollPopups/index.vue'),
    meta: {
      title: '新增工资发放'
    }
  },
  {
    path: getPath('ChoiceSubjects', baseUrl),
    name: 'ChoiceSubjects',
    component: () => import(/* webpackChunkName: "ChoiceSubjects" */ '@/views/paymentWelfare/choiceSubjects/index.vue'),
    meta: {
      title: '选择科目'
    }
  }
]
